import {module as m} from 'modujs';
import 'vlitejs/dist/vlite.css';
import Vlitejs from 'vlitejs';
import VlitejsYoutube from 'vlitejs/dist/providers/youtube';

Vlitejs.registerProvider('youtube', VlitejsYoutube);

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.player = null;
    }

    init() {
        this.player = new Vlitejs(this.$('video')[0], {
            options: {
                autoHide: true,
                poster: this.$('video')[0].dataset.poster
            },
            provider: 'youtube',
            providerParams: {
                enablejsapi: 1,
                rel: 0,
                origin: SITE_URL,
                showinfo: 0
            }
        });
    }
}